import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Container, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SEOHead from '../../components/SEOHead';

/** Unbekannte Adressen: nicht indexieren (vermeidet „Soft 404“ in der Search Console) */
const NotFoundPage: React.FC = () => (
  <Container maxWidth="md" sx={{ py: 20, textAlign: 'center' }}>
    <SEOHead title="404 – Seite nicht gefunden | TOP BHS" noindex />
    <Typography variant="h1" sx={{ fontSize: { xs: '2.5rem', md: '3.5rem' }, mb: 2 }}>404</Typography>
    <Typography variant="h5" sx={{ mb: 4, color: 'text.secondary' }}>Seite nicht gefunden</Typography>
    <Button component={RouterLink} to="/" variant="contained" startIcon={<ArrowBackIcon />}>
      Zur Startseite
    </Button>
  </Container>
);

export default NotFoundPage;
